// 菜鸟打印
import sale from '../services/sale';
import utils from './utils';

let socketArr = [];
let socket;
const msg = '连接打印机失败, 请检查设备和网络';
function print(data, callBack, errCallBack) {
  if (!socketArr.length) {
    socket = new WebSocket('ws://localhost:13528');
    socketArr.push(socket);
  } else {
    socket = socketArr[0];
    if (socket.readyState === 1) {
      socket.send(data);
    } else {
      socketArr = [];
      // eslint-disable-next-line no-alert
      errCallBack(msg);
    }
  }
  try {
    socket.onopen = () => {
      socket.send(data);
    };
    socket.onmessage = (event) => {
      // eslint-disable-next-line no-eval
      const res = JSON.parse(event.data);
      callBack(res);
    };
  } catch (error) {
    socketArr = [];
    // eslint-disable-next-line no-alert
    errCallBack('添加打印失败，请刷新重试');
  }
  socket.addEventListener('error', (event) => {
    socketArr = [];
    if (event.currentTarget.readyState === 3) {
      // eslint-disable-next-line no-alert
      errCallBack(msg);
    }
  });
}
function getPrintData(epId, callBack, errCallBack) {
  const params = {
    epId,
  };
  sale.getPrintData(params).then((res) => {
    if (res.data.status === 200) {
      if (res.data.data) {
        if (JSON.stringify(res.data.data) == '{}') {
          errCallBack('获取打印面单失败，请稍后重试！');
        } else {
          print(JSON.stringify(res.data.data), callBack, errCallBack);
        }
      }
    } else {
      errCallBack(res.data.error);
    }
  }).catch((err) => {
    utils.handleError(err);
  });
}
export default {
  print,
  getPrintData,
};
